import { JavascriptTag } from '@dtk/public-website-ui-components';
import React from 'react';

const JavascriptTagBlok = ({ blok }) => (
  <div>
    <JavascriptTag key={blok._uid} sourceURL={blok.sourceURL} cssStyle={blok.cssStyle}></JavascriptTag>
  </div>
);
export default JavascriptTagBlok;
